// components/Construction/AddressSuggestionDialog.tsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  Typography,
  Box,
  CircularProgress,
  Divider
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { AddressSearchSuggestion } from '../../types/address';

interface AddressSuggestionDialogProps {
  open: boolean;
  onClose: () => void;
  suggestions: AddressSearchSuggestion[];
  loading: boolean;
  onSelectAddress: (address: AddressSearchSuggestion) => void;
  keyword: string;
}

export const AddressSuggestionDialog: React.FC<AddressSuggestionDialogProps> = ({
  open,
  onClose,
  suggestions,
  loading,
  onSelectAddress,
  keyword
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>
        住所候補
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          「{keyword}」の検索結果
        </Typography>
        
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
            <CircularProgress />
          </Box>
        ) : suggestions.length === 0 ? (
          <Box sx={{ p: 2, textAlign: 'center' }}>
            <Typography>住所候補が見つかりませんでした</Typography>
          </Box>
        ) : (
          <List>
            {suggestions.map((suggestion, index) => (
              <React.Fragment key={`address-${index}`}>
                {index > 0 && <Divider />}
                <ListItem 
                  sx={{ p: 2, cursor: 'pointer' }}
                  onClick={() => onSelectAddress(suggestion)}
                >
                  <Box sx={{ display: 'flex', width: '100%', alignItems: 'flex-start' }}>
                    <LocationOnIcon color="primary" sx={{ mr: 2, mt: 0.5 }} />
                    <Box sx={{ flex: 1 }}>
                      {suggestion.title && (
                        <Typography variant="subtitle1" fontWeight="bold">
                          {suggestion.title}
                        </Typography>
                      )}
                      <Typography variant="body1">
                        {suggestion.address || suggestion.normalizedAddress}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        {suggestion.normalizedAddress}
                      </Typography>
                    </Box>
                    <Button 
                      variant="outlined" 
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        onSelectAddress(suggestion);
                      }}
                    >
                      選択
                    </Button>
                  </Box>
                </ListItem>
              </React.Fragment>
            ))}
          </List>
        )}
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose}>キャンセル</Button>
      </DialogActions>
    </Dialog>
  );
};